import React from 'react';
import * as Blocks from '../../blocks';
import AnchorNavHorizontal from '../../components/c-anchornav-horizontal';
import * as Render from '../../platformui/Base/Render';
import withAnchorNav from '../../platformui/Containers/withAnchorNav';
import CollectionPage from '../../platformui/Pages/collection';
import MatomoTrackDataAttribute from '../../platformui/Matomo/matomo-track-data-attribute';
import MatomoTrackMediaAnalytics from '../../platformui/Matomo/matomo-track-media-analytics';

const blockTypes = <Render.BlockTypeRenderer Blocks={Blocks} />;

const CollectionPageUmoYoumo = (props) => {
  const anchorNavLinks =
    props.Content.MainContent?.filter(
      (c) => !c.HideAnchorLink && c.AnchorSectionId && c.Heading
    ).map((c) => ({
      Id: c.AnchorSectionId,
      Name: c.Heading,
    })) || null;

  const isValidActiveId = anchorNavLinks?.some(
    (link) => link.Id === props.currentActiveId
  );

  return (
    <>
      <CollectionPage
        {...props}
        Modifiers={{
          'medium-centered': true,
          'large-uncentered': true,
        }}
        BlockTypeRenderer={blockTypes}
        HorizontalAnchorNavigation={
          props.Content.ShowOnPageNavigation && (
            <AnchorNavHorizontal
              Links={anchorNavLinks}
              currentActiveMenuItem={(id) => props.currentActiveMenuItem(id)}
              currentActiveId={isValidActiveId ? props.currentActiveId : ''}
              translations={props.Content?.Translations}
            />
          )
        }
      />
      <MatomoTrackMediaAnalytics />
      <MatomoTrackDataAttribute />
    </>
  );
};

export default withAnchorNav(CollectionPageUmoYoumo);
